import { api } from "./client";

export interface ReceiptParams {
  page?: number;
  pageSize?: number;
  dateReceivedFrom?: string;
  dateReceivedTo?: string;
  wholesalerId?: string;
  userIds?: string;
  ndc?: string;
  itemName?: string;
  invoiceNumber?: string;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
}

export function getReceipts(params?: ReceiptParams) {
  return api.get("/receipts", { params });
}

export function getReceipt(id: string) {
  return api.get(`/receipts/${id}`);
}

export function createReceipt(data: Record<string, unknown>) {
  return api.post("/receipts", data);
}

export function updateReceipt(id: string, data: Record<string, unknown>) {
  return api.patch(`/receipts/${id}`, data);
}

export function deleteReceipt(
  id: string,
  data?: { password?: string; approvalToken?: string }
) {
  return api.delete(`/receipts/${id}`, { body: data });
}

export function uploadReceiptInvoice(id: string, file: File) {
  const formData = new FormData();
  formData.append("file", file);
  return api.post(`/receipts/${id}/invoice`, formData, { isFormData: true });
}

export function deleteReceiptInvoice(id: string) {
  return api.delete(`/receipts/${id}/invoice`);
}

export function getReceiptInvoiceUrl(id: string) {
  return api.get<{
    data?: { url?: string; file_name?: string };
  }>(`/receipts/${id}/invoice`);
}

export function getLastInvoice() {
  return api.get<{
    data?: { invoice_number?: string };
    invoiceNumber?: string;
  }>("/receipts/last-invoice");
}
